import { SvgReplyRight, TextButton } from '@loomhq/lens';
import React, { Component } from 'react';

class RedoButton extends Component {
  render() {
    const { currentTrimRange, redoStack } = this.props;

    const canRedo = currentTrimRange == null && redoStack.length > 0;

    if (!canRedo) {
      return null;
    }

    return (
      <div className="ml:medium">
        <TextButton icon={<SvgReplyRight />} onClick={this.props.onRedoTrim}>
          Redo
        </TextButton>
      </div>
    );
  }
}

export default RedoButton;
